module.exports = __webpack_public_path__ + "img/e44.defc823b.png";